import { render, staticRenderFns } from "./NavigationDesktop.vue?vue&type=template&id=2024d5b3"
import script from "./NavigationDesktop.vue?vue&type=script&lang=ts"
export * from "./NavigationDesktop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavigationLinkByColor: require('/codebuild/output/src3458403893/src/acredo-website/components/navigation/NavigationLinkByColor.vue').default,NavigationLinkByDesign: require('/codebuild/output/src3458403893/src/acredo-website/components/navigation/NavigationLinkByDesign.vue').default,NavigationLinkText: require('/codebuild/output/src3458403893/src/acredo-website/components/navigation/NavigationLinkText.vue').default,NavigationLinkStartConfiguration: require('/codebuild/output/src3458403893/src/acredo-website/components/navigation/NavigationLinkStartConfiguration.vue').default})
